import {
  getActivityData,
} from '../api';

const services = (dispatch, actions) => ({
  getActivities: (payload) => {
    dispatch(actions.myaccountActions('DATA_LOADING', {loading_activities: true}))
    getActivityData(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_ACTIVITIES', res.data));
    });
  },
});

export default services;
